import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import Modal from "../../../../../components/Modal/Modal";
import LoadingSpinner from "../../../../../components/LoadingSpinner/LoadingSpinner";
import { StyledButton } from "../../../../../components/styled/styled-components";
import {
  IPaymentSessionResponse,
  getPaymentMethodSession,
} from "../../../../order-history/fetch/paymentMethod";
import { OrderSubmitStatuses } from "../../../../../interfaces/enums";
import { PaymentOption } from "../../../payment-selection/sendPaymentSelection";
import { OrderSplitCurrentOrder } from "../../../../../interfaces/interfaces";
import { IContext } from "../../../../../context/ContextApp";
import { Context } from "../../../../../context/ContextApp";
import { subdomainTypes } from "../../../../../context/availableSubdomains";

interface Props {
  orderAccpacNumber: string | null;
  orderId: number;
  submitStatus: OrderSubmitStatuses | null;
  showSyd?: boolean;
  showMel?: boolean;
  showPer?: boolean;
  showAuk?: boolean;
  showCan?: boolean;
  order: OrderSplitCurrentOrder | null;
  changeModalToShow: (modalToShow: number) => void;
}

const OrderResult = ({
  orderAccpacNumber,
  orderId,
  submitStatus,
  showSyd,
  showMel,
  showPer,
  showAuk,
  showCan,
  order,
  changeModalToShow,
}: Props) => {
  const [paymentSessionUrl, setPaymentSessionUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { appBranch }: IContext = useContext(Context);

  const location = useLocation();

  useEffect(() => {
    const loadPaymentSession = async () => {
      setIsLoading(true);
      const redirection_url = `${window.location.origin}/order-history`;
      const responseSession: IPaymentSessionResponse = await getPaymentMethodSession(
        orderId,
        redirection_url,
      );
      if (responseSession.status === 200 && responseSession.session_url !== null) {
        setPaymentSessionUrl(responseSession.session_url);
      }
      setIsLoading(false);
    };

    if (!paymentSessionUrl && appBranch !== subdomainTypes.NZ) loadPaymentSession();
  }, [paymentSessionUrl, orderId, location.pathname, appBranch]);

  const renderBankTransferButton = () => (
    <>
      <StyledButton onClick={() => (window.location.href = `/order-history?order=${orderId}`)}>
        Open Order Details
      </StyledButton>
      <StyledButton onClick={() => changeModalToShow(7)}>Bank Transfer Info</StyledButton>
    </>
  );

  const renderEmailTransferButton = () => (
    <>
      <StyledButton onClick={() => (window.location.href = `/order-history?order=${orderId}`)}>
        Open Order Details
      </StyledButton>
      <StyledButton onClick={() => changeModalToShow(8)}>E-Transfer Info</StyledButton>
    </>
  );

  const renderCCPaymentButton = () => {
    // NZ case
    if (appBranch === subdomainTypes.NZ) {
      return (
        <a href={`/payment-form/${orderId}`}>
          <StyledButton>Pay Order</StyledButton>
        </a>
      );
    }

    if (paymentSessionUrl !== null) {
      return (
        <>
          <a href={paymentSessionUrl || ""}>
            <StyledButton>Pay Order</StyledButton>
          </a>
        </>
      );
    }
    if (isLoading) return <LoadingSpinner />;

    return (
      <>
        <StyledButton onClick={() => window.location.reload()}>Back to store</StyledButton>
        <StyledButton onClick={() => (window.location.href = `/order-history?order=${orderId}`)}>
          Open Order Details
        </StyledButton>
      </>
    );
  };

  const renderPaymentButton = () => {
    if (isLoading) return <LoadingSpinner />;

    return (
      <>
        <StyledButton onClick={() => window.location.reload()}>Back to store</StyledButton>
        <StyledButton onClick={() => (window.location.href = `/order-history?order=${orderId}`)}>
          Open order details
        </StyledButton>
      </>
    );
  };

  return (
    <Modal>
      <div className="order-result">
        <div className="main-content">
          {submitStatus === OrderSubmitStatuses.Success ? (
            showCan && order?.payment_method === PaymentOption.payOnline ? (
              <div className="success">
                <h1>
                  Your order (#{orderAccpacNumber}) will be processed as soon as <b>payment</b> in
                  full has been made.
                </h1>
                <div>Please click on the button below to proceed to payment.</div>
                <div>{renderCCPaymentButton()}</div>
              </div>
            ) : (
              <div className="success">
                <h1>Thank you!</h1>
                <h2>{`Your order (#${orderAccpacNumber}) has been submitted.`}</h2>
                <div className="ship-origin-list">
                  <div>Your order will ship from: </div>
                  <ol>
                    {showSyd && <li>Sydney</li>}
                    {showMel && <li>Melbourne</li>}
                    {showPer && <li>Perth</li>}
                    {showAuk && <li>Auckland</li>}
                    {showCan && <li>Canada</li>}
                  </ol>
                </div>
                <div>
                  You can check out the status of your order{" "}
                  <a href={`/order-history?order=${orderId}`}>here.</a>
                </div>
                <div className="actions">
                  {order?.payment_method === PaymentOption.payOnline && renderCCPaymentButton()}
                  {order?.payment_method === PaymentOption.BankTransfer &&
                    renderBankTransferButton()}
                  {order?.payment_method === PaymentOption.EmailTransfer &&
                    renderEmailTransferButton()}
                  {order?.payment_method === PaymentOption.CreditLimit && renderPaymentButton()}
                  <StyledButton onClick={() => (window.location.href = `/`)}>
                    Go back to Home
                  </StyledButton>
                </div>
              </div>
            )
          ) : (
            <div className="fail">
              <div>
                <h2>Sorry, something went wrong.</h2>
                <h2>Please try again.</h2>
              </div>

              <div className="actions">
                <StyledButton onClick={() => (window.location.href = `/order-history?`)}>
                  Open Order Details
                </StyledButton>

                <StyledButton onClick={() => (window.location.href = `/`)}>
                  Go back to Home
                </StyledButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default OrderResult;
